import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AuthProvider from './contexts/AuthProvider';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ShippingRates from './pages/ShippingRates';
import ZoneExplorer from './pages/ZoneExplorer';
import CoverageMap from './pages/CoverageMap';
import FuelIndex from './pages/FuelIndex';
import Experiments from './pages/Experiments';
import PricingRules from './pages/PricingRules';
import MobileOrders from './pages/MobileOrders';
import MobileSimulate from './pages/MobileSimulate';
import CarrierInvoices from './pages/CarrierInvoices';
import InvoiceShipments from './pages/InvoiceShipments';
import PackingSimulator from './pages/PackingSimulator';
import PackingPrint from './pages/PackingPrint';
import PackagingData from './pages/PackagingData';
import OutPacking from './pages/OutPacking';
import AlgorithmGuide from './pages/AlgorithmGuide';
import CheckoutGuide from './pages/CheckoutGuide';
import ClaudeConnector from './pages/ClaudeConnector';
import FrancoAnalysis from './pages/FrancoAnalysis';
import Benchmark from './pages/Benchmark';
import Inventory from './pages/Inventory';
import ApiHealth from './pages/ApiHealth';
import BugsFeatures from './pages/BugsFeatures';
import PackingFeedback from './pages/PackingFeedback';
import SSOCallback from './pages/SSOCallback';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/sso-callback" element={<SSOCallback />} />
          <Route path="/feedback" element={<PackingFeedback />} />

          <Route
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/packing-simulator" element={<PackingSimulator />} />
            <Route path="/packing-print" element={<PackingPrint />} />
            <Route path="/shipping-rates" element={<ShippingRates />} />
            <Route path="/zones" element={<ZoneExplorer />} />
            <Route path="/coverage-map" element={<CoverageMap />} />
            <Route path="/fuel-index" element={<FuelIndex />} />
            <Route path="/experiments" element={<Experiments />} />
            <Route path="/experiments/:id" element={<Experiments />} />
            <Route path="/pricing-rules" element={<PricingRules />} />
            <Route path="/m/orders" element={<MobileOrders />} />
            <Route path="/m/simulate" element={<MobileSimulate />} />
            <Route path="/carrier-invoices" element={<CarrierInvoices />} />
            <Route path="/carrier-invoices/worklist" element={<CarrierInvoices />} />
            <Route path="/carrier-invoices/activity" element={<CarrierInvoices />} />
            <Route path="/carrier-invoices/files" element={<CarrierInvoices />} />
            <Route path="/carrier-invoices/files/:id" element={<InvoiceShipments />} />
            <Route path="/carrier-invoices/carriers" element={<CarrierInvoices />} />
            <Route path="/carrier-invoices/decisions" element={<CarrierInvoices />} />
            <Route path="/packaging-data" element={<PackagingData />} />
            <Route path="/out-packing" element={<OutPacking />} />
            <Route path="/algorithm-guide" element={<AlgorithmGuide />} />
            <Route path="/checkout-guide" element={<CheckoutGuide />} />
            <Route path="/claude-connector" element={<ClaudeConnector />} />
            <Route path="/franco-analysis" element={<FrancoAnalysis />} />
            <Route path="/benchmark" element={<Benchmark />} />
            <Route path="/inventory" element={<Inventory />} />
            <Route path="/api-health" element={<ApiHealth />} />
            <Route path="/bugs-features" element={<BugsFeatures />} />
          </Route>

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
